import { render, staticRenderFns } from "./DataTableColumn.vue?vue&type=template&id=7441bd3e&"
import script from "./DataTableColumn.vue?vue&type=script&lang=js&"
export * from "./DataTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./DataTableColumn.vue?vue&type=style&index=0&id=7441bd3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports